/* Coral Keepsake: tap-to-fill ready-made dedications. Tapping a message puts it in the dedication box,
   where the customer can keep it or change it. The preview updates exactly as if they had typed it. */
(function(){
 'use strict';
 function sync(root){
  const box=root.querySelector('[data-ckb="dedication"]');if(!box)return;
  for(const b of root.querySelectorAll('[data-ckb-pick]'))b.setAttribute('aria-pressed',String(box.value.trim()===b.dataset.ckbPick));
 }
 document.addEventListener('click',e=>{
  const b=e.target.closest&&e.target.closest('[data-ckb-pick]');if(!b)return;
  const root=b.closest('.ckb-preview'),box=root&&root.querySelector('[data-ckb="dedication"]');if(!box)return;
  e.preventDefault();box.value=b.dataset.ckbPick;box.dispatchEvent(new Event('input',{bubbles:true}));sync(root);
 });
 document.addEventListener('input',e=>{const root=e.target.closest&&e.target.closest('.ckb-preview');if(root)sync(root);});
})();
